import { defineComponent } from 'vue';

export default defineComponent({
  setup(){
    return () => (
      <div>404</div>
    )
  }
})